import * as React from "react";
import Column from "../../../../ui-library/column-system/column";
import Row from "../../../../ui-library/column-system/row";
import { Colors, RainBow } from "../../../../design-tokens/colors";
import {
  CovidCaseByCountry_covidCaseOwidByCountry_data,
  CovidCaseByCountry_covidCaseOwidByCountry_latest,
} from "../../../../../apollo-types/CovidCaseByCountry";
import { AskAboutContext } from "../../../../../site-context/ask-about-context";
import SnapshotItem from "./country-snapshot-item";

interface CountrySnapshotProps {
  countryPageUrl?: string;
  covidData: CovidCaseByCountry_covidCaseOwidByCountry_data[];
  lastDayValue: CovidCaseByCountry_covidCaseOwidByCountry_latest;
  isMobileScrollable?: boolean;
}

const CountrySnapshot: React.FC<CountrySnapshotProps> = ({
  countryPageUrl,
  covidData,
  lastDayValue,
  isMobileScrollable,
}) => {
  const {
    store: { isMobile },
  } = React.useContext(AskAboutContext);

  const {
    totalCases,
    totalRecovered,
    totalDeaths,
    totalActive,
    totalTests,
    newCases,
    newDeaths,
    newRecovered,
    newActive,
    newTests,
    fatalityRate,
    fatalityRateChange,
  } = lastDayValue;

  const isInline = isMobile && isMobileScrollable;

  return (
    <Row isInline={isInline}>
      <Column
        spanLg={2}
        spanMd={4}
        spanSm={6}
        spanXs={6}
        isInline={isInline}
        inlineWidth={140}
      >
        <SnapshotItem
          value={totalCases || "N/A"}
          label="Cases"
          change={newCases}
          element="dailyConfirm"
          color={Colors.Pink}
          countryPageUrl={countryPageUrl}
          covidData={covidData}
          dataKey="totalCases"
        />
      </Column>
      <Column
        spanLg={2}
        spanMd={4}
        spanSm={6}
        spanXs={6}
        isInline={isInline}
        inlineWidth={140}
      >
        <SnapshotItem
          value={totalActive && totalActive >= 0 ? totalActive : "N/A"}
          label="Active"
          change={totalActive && totalActive >= 0 ? newActive : null}
          element={totalActive ? "dailyActive" : undefined}
          color={Colors.Orange}
          countryPageUrl={countryPageUrl}
          covidData={covidData}
          dataKey="totalActive"
        />
      </Column>
      <Column
        spanLg={2}
        spanMd={4}
        spanSm={6}
        spanXs={6}
        isInline={isInline}
        inlineWidth={140}
      >
        <SnapshotItem
          value={totalRecovered || "N/A"}
          label="Recoveries"
          change={newRecovered}
          isPositive={true}
          element={totalRecovered ? "dailyRecovered" : undefined}
          color={Colors.Green}
          countryPageUrl={countryPageUrl}
          covidData={covidData}
          dataKey="totalRecovered"
        />
      </Column>
      <Column
        spanLg={2}
        spanMd={4}
        spanSm={6}
        spanXs={6}
        isInline={isInline}
        inlineWidth={140}
      >
        <SnapshotItem
          value={totalTests || "N/A"}
          label="Tests"
          change={newTests}
          isPositive={true}
          element={totalTests ? "dailyTested" : undefined}
          color={RainBow.GrassGreen}
          countryPageUrl={countryPageUrl}
          covidData={covidData}
          dataKey="totalTests"
        />
      </Column>
      <Column
        spanLg={2}
        spanMd={4}
        spanSm={6}
        spanXs={6}
        isInline={isInline}
        inlineWidth={140}
      >
        <SnapshotItem
          value={totalDeaths || "N/A"}
          label="Deaths"
          change={newDeaths}
          element={totalDeaths ? "dailyDeath" : undefined}
          color={Colors.Red}
          countryPageUrl={countryPageUrl}
          covidData={covidData}
          dataKey="totalDeaths"
        />
      </Column>
      <Column
        spanLg={2}
        spanMd={4}
        spanSm={6}
        spanXs={6}
        isInline={isInline}
        inlineWidth={140}
      >
        <SnapshotItem
          value={fatalityRate || "N/A"}
          change={fatalityRateChange}
          label="Fatality"
          isPercent={true}
          element={fatalityRate ? "dailyFatalityRate" : undefined}
          color={Colors.Red}
          countryPageUrl={countryPageUrl}
          covidData={covidData}
          dataKey="fatalityRate"
        />
      </Column>
    </Row>
  );
};

export default CountrySnapshot;
